import { render } from "./ChatHistory.vue?vue&type=template&id=4345d42e&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"

import "./ChatHistory.vue?vue&type=style&index=0&id=4345d42e&lang=css"
import "./ChatHistory.vue?vue&type=style&index=1&id=4345d42e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4345d42e"]])

export default __exports__